function initUspsSliders() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-usps-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var items = el.querySelectorAll('.usps__slide');
    var count = items.length;
    if (count === 0) return;

    var perPageDesktop = Math.min(count, 4);

    var mobileGap = '10px';
    var mobilePerView = 1.33;
    var mobileSlideWidth = 'calc((100% + ' + mobileGap + ')/' + mobilePerView + ' - ' + mobileGap + ')';

    var slider = new Splide(el, {
      type: 'slide',
      perPage: perPageDesktop,
      perMove: 1,
      gap: '16px',
      pagination: false,
      arrows: false,
      drag: true,
      breakpoints: {
        1200: {
          perPage: Math.min(count, 3),
          gap: '16px'
        },
        991: {
          perPage: 1,
          perMove: 1,
          gap: mobileGap,
          fixedWidth: mobileSlideWidth,
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var container = el.closest('.section-usps') || el.parentElement;
    var prevBtns = container.querySelectorAll('.usps__arrow--prev');
    var nextBtns = container.querySelectorAll('.usps__arrow--next');

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        slider.go('<');
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        slider.go('>');
      });
    });

    var progressBar = container.querySelector('.usps__progress-bar') || container.querySelector('.splide__progress__bar');

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;

      var index = Math.min(Math.max(slider.index, 0), end);

      if (progressBar) {
        var rate = end > 0 ? Math.min((index + 1) / (end + 1), 1) : 1;
        progressBar.style.width = String(100 * rate) + '%';
      }

      prevBtns.forEach(function (btn) {
        if (index <= 0) {
          btn.classList.add('is-disabled');
        } else {
          btn.classList.remove('is-disabled');
        }
      });

      nextBtns.forEach(function (btn) {
        if (index >= end) {
          btn.classList.add('is-disabled');
        } else {
          btn.classList.remove('is-disabled');
        }
      });
    }

    slider.on('mounted move moved updated refresh resized scrolled', syncControls);
    slider.mount();
    el.classList.add('is-initialized');
  });
}

document.addEventListener('DOMContentLoaded', initUspsSliders);
window.addEventListener('load', initUspsSliders);
document.addEventListener('shopify:section:load', initUspsSliders);

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.js-usps-splide') || node.querySelector('.js-usps-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initUspsSliders();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
